import { useCallback, useState } from 'react';

import { useSessao } from '@/modulos/sessao/consultas';

import { armazemDoNavegador, chaveDoUltimo, lembrado, lembrar } from './preenchimento';

/**
 * O ÚLTIMO VALOR QUE ESTA PESSOA USOU num campo (o depósito, por exemplo),
 * neste navegador. Lido uma vez, quando o formulário abre; gravado quando o
 * lançamento dá certo — o que foi recusado não vira costume.
 */
export function useUltimoUsado(campo: string): readonly [string | null, (valor: string) => void] {
  const usuarioId = useSessao().data?.usuarioId ?? null;
  const chave = usuarioId === null ? null : chaveDoUltimo(usuarioId, campo);
  const [lido] = useState(() => (chave === null ? null : lembrado(armazemDoNavegador(), chave)));
  const guardar = useCallback(
    (valor: string) => {
      if (chave !== null) lembrar(armazemDoNavegador(), chave, valor);
    },
    [chave],
  );
  return [chave === null ? null : (lido ?? lembrado(armazemDoNavegador(), chave)), guardar] as const;
}
